/**
 * KAN-846: вход по логину и паролю. Логин - почта или телефон менеджера:
 * backend принимает оба в поле email.
 *
 *   POST /api/v1/auth/login/ {email, password} - {access, refresh, user};
 *        401 {detail: "Неверный логин или пароль"}
 */
import apiClient from './client';
import type { AppLinkLoginResponse } from './appLink';

export const passwordLoginApi = {
  async login(login: string, password: string): Promise<AppLinkLoginResponse> {
    const res = await apiClient.post<AppLinkLoginResponse>('/api/v1/auth/login/', { email: login, password });
    return res.data;
  },
};
